"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledChangeMark = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledChangeMark = styled_components_1.default.div `
  box-sizing: border-box;
  cursor: default;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.primary.main};
  width: 0.5rem;
  height: 0.5rem;
  margin: ${({ theme }) => theme.spacing(0.5)};
`;
